import { motion } from 'framer-motion';
import React from 'react';

/**
 * ProgressDots — shows current step progress as dots.
 */
export default function ProgressDots({ total, current }) {
  return (
    <div
      className="flex items-center justify-center gap-1.5"
      aria-label={`Step ${current + 1} of ${total}`}
    >
      {Array.from({ length: total }).map((_, i) => (
        <motion.div
          key={i}
          className="rounded-full"
          animate={{
            width: i === current ? 20 : 8,
            height: 8,
            backgroundColor:
              i === current
                ? '#f43f5e'
                : i < current
                ? '#fda4af'
                : '#fce7f3',
          }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
      ))}
    </div>
  );
}
